import React from "react";
import classes from "./WelcomeMessage.module.css";
import apple from "./../../assets/images/apple.png";
import android from "./../../assets/images/android.png";
import information from "./../../assets/images/information_project.png";
import zitsafund from "./../../assets/images/zitsafund.png";
import SvgTermsofuse2 from "./../../assets/icons/Termsofuse2";
import { useHistory } from "react-router-dom";

const sponsor_logo = zitsafund;
const WelcomeMessage = (props) => {
  const history = useHistory();
  return (
    <div className={classes.container}>
      <div style={{ padding: "20px", lineHeight: "26px" }}>
        <p
          style={{
            color: "#fff",
            fontWeight: "700",
          }}
        >
          Ο Δήμος {props.municipality} σας καλωσορίζει στην Πλατφόρμα Εξυπνης
          Πόλης.
        </p>
        <p
          style={{
            color: "#fff",
            fontWeight: "700",
          }}
        >
          Ενημερωθείτε για τις συνθήκες που επικρατούν στην πόλη μας.
        </p>
      </div>
      <div>
        <div
          style={{
            background: "#fff",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <img
            src={sponsor_logo}
            alt="interreg logo"
            className={classes.epsa_logo}
          />
          {/* <span
            style={{
              fontSize: "12px",
              color: "#2a7da7",
              paddingLeft: "14px",
              paddingBottom: "10px",
              fontWeight: "600",
            }}
          >
            Με τη συγχρηματοδότηση της Ελλάδας και της Ευρωπαϊκής Ένωσης
          </span> */}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            color: "#fff",
            fontWeight: "600",
            alignItems: "center",
            marginTop: "10px",
            backgroundColor: "black",
            border: "1px solid #BCBCBB",
            padding: "6px",
            borderRadius: "4px",
            cursor: "pointer",
          }}
          onClick={() => history.push("/terms-of-use")}
        >
          <SvgTermsofuse2 width={35} />
          <p>Δήλωση Προσβασιμότητας</p>
        </div>
      </div>
    </div>
  );
};
export default WelcomeMessage;
